export default __webpack_public_path__ + "4cb9f0d10e1184cb7efd2014d7ca7a8e.png";